<template>
  <div class="doc-section">
    <div class="section-header">
      <span class="material-icons-sharp section-icon">reduce_capacity</span>
      <h2>Réductions &amp; Bonus</h2>
    </div>

    <p class="section-intro">
      Ce module gère les demandes de réduction et les simulations de bonus.
      L'administrateur peut accepter ou rejeter les demandes, et lancer des simulations
      pour calculer les bonus clients.
    </p>

    <!-- ===== DEMANDE DE RÉDUCTION ===== -->
    <h3 class="sub-title">Traiter une demande de réduction (Admin)</h3>
    <p class="section-text">
      Lorsqu'un commercial soumet une demande de réduction pour un client, elle apparaît ici.
      Tous les champs sont en lecture seule :
    </p>
    <div class="table-wrapper">
      <table>
        <thead>
          <tr><th>Information</th><th>Description</th></tr>
        </thead>
        <tbody>
          <tr><td><strong>Client</strong></td><td>Nom du client concerné.</td></tr>
          <tr><td><strong>Produit</strong></td><td>Produit pour lequel la réduction est demandée.</td></tr>
          <tr><td><strong>Quantité</strong></td><td>Quantité achetée.</td></tr>
          <tr><td><strong>Prix unitaire</strong></td><td>Prix actuel du produit.</td></tr>
          <tr><td><strong>Réduction demandée</strong></td><td>Montant ou pourcentage de réduction.</td></tr>
          <tr><td><strong>Observation</strong></td><td>Justification du commercial.</td></tr>
        </tbody>
      </table>
    </div>

    <h4 class="sub-title">Procédure</h4>
    <div class="steps">
      <div class="step-item">
        <div class="step-num">1</div>
        <p>Ouvrez le module <strong>Réductions</strong> depuis le menu latéral.</p>
      </div>
      <div class="step-item">
        <div class="step-num">2</div>
        <p>Cliquez sur une demande en attente dans le tableau.</p>
      </div>
      <div class="step-item">
        <div class="step-num">3</div>
        <p>Examinez les détails de la demande.</p>
      </div>
      <div class="step-item">
        <div class="step-num">4</div>
        <p><strong>Pour approuver :</strong> Cliquez sur <span class="btn-ref">Accepter la demande</span>. La réduction est appliquée.</p>
      </div>
      <div class="step-item">
        <div class="step-num">5</div>
        <p><strong>Pour refuser :</strong> Cliquez sur <span class="btn-ref">Rejeter la demande</span>.</p>
      </div>
    </div>

    <!-- ===== SIMULATION DE BONUS ===== -->
    <h3 class="sub-title">Simulation de bonus</h3>
    <p class="section-text">
      La simulation permet de calculer les bonus à accorder aux clients fidèles selon des critères paramétrables.
    </p>

    <div class="table-wrapper">
      <table>
        <thead>
          <tr><th>Champ</th><th>Type</th><th>Obligatoire</th><th>Ce qu'il faut saisir</th></tr>
        </thead>
        <tbody>
          <tr><td><strong>Produit</strong></td><td>Liste déroulante</td><td><span class="required-badge badge-yes">Oui</span></td><td>Le produit pour lequel simuler le bonus.</td></tr>
          <tr><td><strong>Seuil quantité</strong></td><td>Nombre</td><td><span class="required-badge badge-yes">Oui</span></td><td>Quantité minimum achetée pour bénéficier du bonus.</td></tr>
          <tr><td><strong>Montant bonus</strong></td><td>Nombre</td><td><span class="required-badge badge-yes">Oui</span></td><td>Montant du bonus à accorder.</td></tr>
          <tr><td><strong>Période (début - fin)</strong></td><td>Dates</td><td><span class="required-badge badge-yes">Oui</span></td><td>Période de calcul.</td></tr>
        </tbody>
      </table>
    </div>

    <h4 class="sub-title">Procédure de simulation</h4>
    <div class="steps">
      <div class="step-item">
        <div class="step-num">1</div>
        <p>Allez dans la section <strong>Simulation</strong> du module Réductions.</p>
      </div>
      <div class="step-item">
        <div class="step-num">2</div>
        <p>Sélectionnez le <em>Produit</em>, saisissez le <em>Seuil quantité</em>, le <em>Montant bonus</em> et la <em>Période</em>.</p>
      </div>
      <div class="step-item">
        <div class="step-num">3</div>
        <p>Cliquez sur <span class="btn-ref">Lancer la simulation</span>. Le système calcule la liste des clients éligibles.</p>
      </div>
      <div class="step-item">
        <div class="step-num">4</div>
        <p>Le tableau des résultats affiche chaque client éligible avec la quantité achetée et le bonus calculé.</p>
      </div>
      <div class="step-item">
        <div class="step-num">5</div>
        <p>Pour appliquer le bonus aux clients éligibles, cliquez sur <span class="btn-ref">Appliqué le bonus</span>. Les portefeuilles clients sont crédités.</p>
      </div>
    </div>

    <div class="info-card tip">
      <div class="card-title">
        <span class="material-icons-sharp" style="font-size:16px;color:#4caf50">lightbulb</span>
        Astuce
      </div>
      <p>
        Lancez la simulation sans appliquer le bonus pour prévisualiser les résultats.
        Vous pouvez ajuster les paramètres et relancer autant de fois que nécessaire avant d'appliquer.
      </p>
    </div>
  </div>
</template>
<script>
export default { name: "DocReduction" };
</script>
